/** Messages auth backend FR/EN — BT-049 / BT-050 (karateUiI18n). */
import { getKarateUi } from "@/i18n/karateUiI18n.js";

export function getAuthErrorMessage(err, locale = "fr") {
  const ui = getKarateUi(locale).backendStaging;
  const payload = err?.payload;
  if (payload?.messageEn && locale === "en") return payload.messageEn;
  if (payload?.messageFr && locale === "fr") return payload.messageFr;
  if (payload?.message) return payload.message;
  if (payload?.error === "PASSWORD_CHANGE_REQUIRED") {
    return locale === "en" ? payload.messageEn : payload.messageFr;
  }
  if (payload?.error === "WEAK_PASSWORD") {
    return locale === "en" ? payload.messageEn : payload.messageFr;
  }
  if (err?.status === 403) return ui.authError403;
  if (err?.status === 401) return ui.authError401;
  return ui.authErrorBackend;
}

export function getStagingPasswordNotice(locale, payload) {
  const ui = getKarateUi(locale).backendStaging;
  if (locale === "en") return payload?.stagingPasswordNoticeEn || ui.tempPasswordNoticeBackend;
  return payload?.stagingPasswordNoticeFr || ui.tempPasswordNoticeBackend;
}

export function getHybridModeLabel(locale, { backendReachable, dataMode }) {
  const ui = getKarateUi(locale).backendStaging;
  if (!backendReachable && dataMode !== "local") return ui.hybridUnreachable;
  if (dataMode === "backend") return ui.hybridBackend;
  if (dataMode === "hybrid") return ui.hybridHybrid;
  return ui.hybridLocal;
}
